export default function generatePageTitles(pageName) {
  return `${pageName} - Zcruit`;
}
